import { TravelDates } from 'types/legacy/backendInformation';

import { GeoCoordinate } from 'proto/MapData/GeoCoordinate';
import { FilterInformation } from 'proto/Search/FilterMeta';

import { Iata } from './airport';
import { AirportValue, Filter } from './filter';

export enum ValidationType {
    Destination = 'destination',
    DepartureAirport = 'departureAirport',
    Duration = 'duration',
    TravelDates = 'travelDates',
}
export enum DurationType {
    Range = 'range',
    Day = 'day',
    Week = 'week',
    Exact = 'exact',
    Empty = 'empty',
}

export type DurationValue =
    | { type: DurationType.Exact | DurationType.Empty }
    | {
          type: DurationType.Week | DurationType.Day;
          amount: number;
      }
    | {
          type: DurationType.Range;
          min: number;
          max: number;
      };

export interface Room {
    adultCount: number;
    childAgeList: number[];
}

export type OccupancyValue = Room[];

export interface Occupancy {
    adultCount: number;
    childCount: number;
    allocation: OccupancyValue;
}

export enum DirectSearchType {
    Hotel = 'h', //currentStep === Offer ? Offer : Hotel
    City = 'ci', //always hotel step
    Region = 'r', //always hotel step
    Country = 'co', // killS2Enabled && resolve ? Hotel : Region, also
    RegionGroup = 'rg', // killS2Enabled && resolve ? Hotel : Region
    CtsDestination = 'cts', //always hotel step
}

// always region step
export enum FlightDistance {
    Short = 'short',
    Middle = 'middle',
    Long = 'long',
}

export enum SearchStep {
    Region = 'Region', //Step 2 (DirectSearchType must be always Region)
    Hotel = 'Hotel', //Step 3
    Offer = 'Offer', //Step 4
}

export interface DestinationValue {
    label?: string;
    directSearch?: DirectSearchType;
    hotelId?: number;
    cityIdList: Set<number>;
    regionIdList: Set<number>;
    countryIdList: Set<number>;
    regionGroupIdList: Set<number>;
    ctsDestination?: number;
    flightDistance?: FlightDistance;
    searchStep?: SearchStep;
    geoFence?: GeoFence;
}

export interface GeoFence {
    northEast: GeoCoordinate;
    southWest: GeoCoordinate;
    zoom: number;
}

export interface Destination extends DestinationValue {
    directHotelSearchId?: number;
}

export interface TravelPeriod {
    departureDate?: Date;
    returnDate?: Date;
    duration: DurationValue;
}

export interface BackendConfig {
    defaultDaysBetween: number;
    maxFutureDay: number;
    maxRange: number;
    minDaysBetween: number;
    delayForEndElementCloseAfterRangeComplete: number;
    travelDates: TravelDates | null;
    holidays: Date[];
    vacations: Date[];
    format: string;
    numberofMonths: number;
    dateTimeFormatOptions: Intl.DateTimeFormatOptions;
}

export enum SortOrder {
    Airport = 'airport',
    Departure = 'departure',
    DistanceCityCenter = 'distanceCityCenter',
    FlightDuration = 'flighttime',
    LowestPrice = 'lowestPrice',
    Popularity = 'categoryDistribution',
    Price = 'price',
    Rating = 'rating',
    Region = 'name',
    TopRegion = 'topregion',
    TravelDuration = 'travelDuration',
    PersonalPopularityIndex = 'personalPopularityIndex',
}

export interface Sorting {
    region?: SortOrder;
    hotel?: SortOrder;
    offer?: SortOrder;
}

export interface Pagination {
    pageCount: number;
    currentPage: number;
}

export type UnknownParams = Record<string, string>;

export interface Search {
    destination: Destination;
    departureAirportList: AirportValue<Iata>;
    occupancy: Occupancy;
    travelPeriod: TravelPeriod;
    sorting: Sorting;
    pagination: Pagination;
    filter: Filter;
    unknownParams: UnknownParams;
}

export interface SearchFormState {
    current: Search;
    recent: Search | null;
    default: Search;
    meta: FilterInformation;
}
